import React from 'react';

interface OnlineStatusProps {
  isOnline: boolean;
  lastSeen?: string;
  className?: string;
}

export const OnlineStatus: React.FC<OnlineStatusProps> = ({ 
  isOnline, 
  lastSeen, 
  className = '' 
}) => {
  const formatLastSeen = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return date.toLocaleDateString();
  };

  return (
    <div className={`flex items-center space-x-1 text-xs ${className}`}>
      <div 
        className={`w-2 h-2 rounded-full ${
          isOnline ? 'bg-green-500' : 'bg-gray-400'
        }`}
      />
      <span className="text-gray-500">
        {isOnline ? 'Online' : lastSeen ? `Active ${formatLastSeen(lastSeen)}` : 'Offline'}
      </span>
    </div>
  );
};